// extracted by mini-css-extract-plugin
var _1 = "DueDatesSection-modulebody__xODBD SettingsFormSectionContent-modulebody__Hug4g";
var _2 = "DueDatesSection-modulefieldSkeleton__g4mMb SettingsField-moduleSettingsField__fY88b Field-moduleField__kZH_K";
export { _1 as "body", _2 as "fieldSkeleton" }
